module.exports = __webpack_public_path__ + "img/155-credit-card.c81611d2.svg";